import ROUTES from '@/lib/constants/routeConfig';
import {
  BookOpenText,
  LayoutDashboard,
  MessageCircle,
  MessagesSquare,
  ScanSearch,
  SearchCheck,
  Sparkles,
  User,
  ScrollText,
  ClipboardPenLine,
  Route as RouteIcon,
} from 'lucide-react';
import { Route } from '../types';
import { useI18n } from '@/locales/client';

export function useRoutes() {
  const t = useI18n();

  const baseRoutes: Route[] = [
    {
      path: ROUTES.HOME,
      icon: MessagesSquare,
      title: t('navigation.chatbot'),
    },
    {
      path: ROUTES.AI_TOOLS.ROOT,
      icon: Sparkles,
      title: t('navigation.aiTools'),
      subRoutes: [
        // DOCUMENTS (Formal Notice and Forms)
        {
          path: ROUTES.AI_TOOLS.DASHBOARD,
          icon: LayoutDashboard,
          title: t('navigation.aiToolDashboard'),
          description: t('navigation.aiToolDashboardDescription'),
          comingSoon: false,
          featureFlagKey: 'FORM_LIBRARY',
        },

        // DOCUMENTS (Formal Notice and Forms)
        {
          path: ROUTES.AI_TOOLS.MY_DOCUMENTS,
          icon: BookOpenText,
          title: t('navigation.myDocuments'),
          description: t('navigation.myDocumentsDescription'),
          comingSoon: false,
          featureFlagKey: 'FORM_LIBRARY',
        },

        // DOCUMENTS (Formal Notice and Forms)
        {
          path: ROUTES.AI_TOOLS.FORMAL_NOTICE,
          icon: ScrollText,
          title: t('navigation.formalNotice'),
          description: t('navigation.formalNoticeDescription'),
          comingSoon: false,
          featureFlagKey: 'FORMAL_NOTICE',
        },

        {
          path: ROUTES.AI_TOOLS.LEGAL_FORMS.CHOICE,
          icon: ClipboardPenLine,
          title: t('navigation.legalForms'),
          description: t('navigation.legalFormsDescription'),
          comingSoon: false,
          featureFlagKey: 'LEGAL_FORMS',
        },

        // CASE LAW
        {
          path: ROUTES.AI_TOOLS.CASE_LAW,
          icon: ScanSearch,
          title: t('navigation.caseLawResearch'),
          description: t('navigation.caseLawResearchDescription'),
          comingSoon: false,
          featureFlagKey: 'CASE_LAW_RESEARCH',
        },

        {
          path: ROUTES.AI_TOOLS.PARCOURS.ROOT,
          icon: RouteIcon,
          title: 'Parcours', //t('navigation.caseLawResearch'),
          description: 'Parcours', //t('navigation.caseLawResearchDescription'),
          comingSoon: false,
          featureFlagKey: 'PARCOURS',
        },
      ],
    },
  ];

  const lawyerRoutes: Route[] = [
    {
      path: ROUTES.DASHBOARD.ROOT,
      icon: LayoutDashboard,
      title: t('navigation.dashboard'),
      subRoutes: [
        {
          path: ROUTES.DASHBOARD.ROOT,
          icon: LayoutDashboard,
          title: t('navigation.overview'),
          description: t('navigation.overviewDescription'),
          featureFlagKey: 'MARKETPLACE',
        },
        {
          path: ROUTES.DASHBOARD.CONVERSATIONS,
          icon: MessageCircle,
          title: t('navigation.conversations'),
          description: t('navigation.conversationsDescription'),
          comingSoon: false,
          featureFlagKey: 'MARKETPLACE',
        },
        {
          path: ROUTES.DASHBOARD.PROFILE,
          icon: User,
          title: t('navigation.myProfile'),
          description: t('navigation.myProfileDescription'),
        },
      ],
    },
  ];

  const userRoutes: Route[] = [
    {
      path: ROUTES.MARKETPLACE.ROOT,
      icon: SearchCheck,
      title: t('navigation.marketplace'),
      subRoutes: [
        {
          path: ROUTES.MARKETPLACE.ROOT,
          icon: SearchCheck,
          title: t('navigation.marketplaceOverview'),
          description: t('navigation.marketplaceOverviewDescription'),
          featureFlagKey: 'MARKETPLACE',
        },
        {
          path: ROUTES.MARKETPLACE.CONVERSATIONS,
          icon: MessageCircle,
          title: t('navigation.marketplaceConversations'),
          description: t('navigation.marketplaceConversationsDescription'),
          comingSoon: false,
          featureFlagKey: 'MARKETPLACE',
        },
        {
          path: ROUTES.MARKETPLACE.PROFILE,
          icon: User,
          title: t('navigation.marketplaceProfile'),
          description: t('navigation.marketplaceProfileDescription'),
        },
      ],
    },
  ];

  return { baseRoutes, lawyerRoutes, userRoutes };
}
